import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"

export default props =>{
    useStyles(classes);
    const {starScore,isComment} = props;

    return (
        <React.Fragment>
            {
                starScore && starScore > 0 && <ol className={`${classes.PStars} ${!!isComment?classes.CommentPStars:""} ${props?.className?props.className:""}`}>
                    {
                        [1,2,3,4,5].map((item,index) => {
                            if(starScore > index){
                                return starScore < index + 1 ? (<li className={classes.Half} key={item}></li>) : (<li className={classes.Active} key={item}></li>);
                            }else{
                                return (<li key={item}></li>)
                            }
                        })
                    }
                </ol>
            }
        </React.Fragment>
    )
}